<template>
<v-card height="90%">
  <v-card-title class="font-weight-bold text-h5">
    メンバー
    <v-spacer></v-spacer>
    <v-btn
      tile
      icon
      style="color:white !important; font-size:15px;"
      class="font-weight-bold"
      @click="$emit('listMemSpClose', false)"
    >
      <v-icon color="#E64550" size="50">mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card elevation="0" class="text-center">
          <v-row>
            <v-col>
              <p v-if="mode=='lid'"><span class="font-weight-bold" style="font-size:26px;" v-text="lidTitle" v-if="lidTitle"></span></p>
              <p v-else><span class="font-weight-bold" style="font-size:26px;" v-text="basetitle" v-if="basetitle"></span></p>
              <v-card-text class="d-flex text-subtitle-1 px-12 py-0"><span class="mr-auto abyssFont">メンバー</span>{{usersNum}}人</v-card-text>
              <v-card-text class="d-flex text-subtitle-1 px-12 py-0"><span class="mr-auto abyssFont">自治体職員（管理者）</span>{{baseAdmins.gov.length}}人</v-card-text>
            </v-col>
          </v-row>  
        </v-card>
      </v-col>
      <v-col cols="12">
        <div class="member-search" >
          <v-col cols="11" class="search" align="right">
            <v-text-field 
              class="searchBox" 
              v-model="keyword" 
              flat outlined dense hide-details
              placeholder="キーワードを入力" 
              prepend-inner-icon="mdi-magnify" s
              tyle="width: 250px; height: 38px;" 
            ></v-text-field>
          </v-col>
        </div>
        <v-card
          height="400"
          color="#DCDCDC"
          elevation="0"
          class="px-4"
        >
          <v-divider></v-divider>
          <!--メンバー編集モード-->
          <v-list v-if="realCondition=='edit'" max-width="500" max-height="98%" class="overflow-y-auto">
            <v-list-item
              v-for="item in filteredUsers"
              :key="item.uid"
              :input-value="onoff[item.uid]"
              @click="onChange(item.uid);"
              color="blue"
              style="height:50px;"
            >
              <v-avatar >
                <!-- <v-img
                  src="https://cdn.vuetifyjs.com/images/john.jpg"
                  alt="John"
                  max-height="35"
                  max-width="35"
                  color="white"
                ></v-img> -->
                <!-- <v-img
                  src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                  alt="John"
                  max-height="35"
                  max-width="35"
                  color="white"
                ></v-img> -->
                <v-icon max-height="50" max-width="50" size="45" style="color:rgba(128,128,128,0.4)!important;">
                  mdi-account-circle
                </v-icon>
                <!-- <span class="white--text text-h5" height="35" width="35">CJ</span> -->
              </v-avatar>
                <!--
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                -->
                <v-list-item-content v-if="sanka[item.uid]=='参加'">
                  <v-list-item-content v-if="item.uid">
                    <v-list-item-title style="color:rgba(0,0,0,0.9) !important; font-family: mplus-2c !important; font-weight: 550 !important;" v-text="` ${namelist[item.uid]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.8) !important; font-family: mplus-2c;" v-text="` 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-content v-if="sanka[item.uid]=='不参加'">
                  <v-list-item-content v-if="item.uid">
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="` 不参加  : ${namelist[item.uid]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="` 不参加  : 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-action v-if="baseAdmins.gov">
                  <v-list-item-action-text class="pt-2" v-if="baseAdmins.gov.some((el) => el === item.uid)">自治体職員（管理者）</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="govstaffs.some((el) => el === item.uid)">自治体職員</v-list-item-action-text>
                </v-list-item-action>
            </v-list-item>
            <v-list-item-content v-if="!filteredUsers.length"> <div align="center">ユーザーはいません</div></v-list-item-content>
          </v-list>
          <!--表示onlyモード-->
          <v-list max-width="500" max-height="98%" class="overflow-y-auto" v-else-if="realCondition=='display'">
            <v-list-item
              v-for="item in filteredUsers"
              :key="item.uid"
              color="blue"
              style="height:50px;"
            >
              <v-avatar >
                <!-- <v-img
                  src="https://cdn.vuetifyjs.com/images/john.jpg"
                  alt="John"
                  max-height="35"
                  max-width="35"
                  color="white"
                ></v-img> -->
                <!-- <v-img
                  src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                  alt="John"
                  max-height="35"
                  max-width="35"
                  color="white"
                ></v-img> -->
                <v-icon max-height="50" max-width="50" size="45" style="color:rgba(128,128,128,0.4)!important;">
                  mdi-account-circle
                </v-icon>
                <!-- <span class="white--text text-h5" height="35" width="35">CJ</span> -->
              </v-avatar>
                <!--
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                -->
                <v-list-item-content v-if="sanka[item.uid]=='参加'">
                  <v-list-item-content v-if="item.uid">
                    <v-list-item-title style="color:rgba(0,0,0,0.9) !important; font-family: mplus-2c !important; font-weight: 550 !important;" v-text="` ${namelist[item.uid]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.8) !important; font-family: mplus-2c;" v-text="` 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-content v-if="sanka[item.uid]=='不参加'">
                  <v-list-item-content v-if="item.uid">
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="` 不参加  : ${namelist[item.uid]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="` 不参加  : 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-action v-if="baseAdmins">
                  <v-list-item-action-text class="pt-2" v-if="baseAdmins.liq.some((el) => el === item.uid)">Liquitous職員</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-if="baseAdmins.gov.some((el) => el === item.uid)">自治体職員（管理者）</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="govstaffs.some((el) => el === item)">自治体職員</v-list-item-action-text>
                </v-list-item-action>
            </v-list-item>
            <v-list-item-content v-if="filteredUsers.length==0" class="text-center"> <p>ユーザーはいません</p></v-list-item-content>
          </v-list>
        </v-card>
        <v-card-actions v-if="false">
          <!--<display>Lid/addLid/pjモード:メンバーを編集-->
          <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='edit'" v-if="isAdmin&&realCondition!='edit'&&(mode=='lid'||mode=='addLid'||mode=='pj')">メンバーを編集</v-btn>
          <!--<edit>Lidモード:Lidメンバーを直接firestoreに登録-->
          <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',submitLidMember()" v-if="(isAdmin&&realCondition=='edit')&&mode=='lid'">完了</v-btn>
          <!--<edit>pjモード:pjメンバーを直接firestoreに登録-->
          <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',submitPjMember()" v-if="(isAdmin&&realCondition=='edit')&&mode=='pj'">完了</v-btn>
          <!--<edit>addLidモード:Lidメンバーを確定、addLid.vueにデータを渡す(firestoreには登録せず)-->
          <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',$emit('lidCandiMems', selectedMembers)" v-else-if="(isAdmin&&realCondition=='edit')&&mode=='addLid'">完了</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-container>
</v-card>
</template>

<script>
import firebase from 'firebase'
//import { join } from 'path'; //不明
export default {
    props:{
      lidId: String,
      lidTitle: String,
      mode: String, //lid,addLid,base
      pjuid: String
    },
    data: () => ({
      db: null,
      candiMembers: [], //参加候補ユーザーの元のデータ（メンバー編集時に参加済と未参加の区別に用いる）
      selectedMembers: [], //参加予定ユーザーを編集するデータ（メンバー編集時に参加済と未参加の区別に用いる）
      keyword: '',
      onoff:{},
      sanka:{},
      sanka_copy: {},
      realCondition: "display",
      isStart: false,
      usersNum:0, //メンバー数表示
      todayy: ""
    }),
    created(){
      //初期設定：(Lidモードの場合)Lidメンバー情報取得、ベースメンバー情報取得、candiMembers_copy初期化
      this.db = firebase.firestore()
      if(this.mode=="lid") this.$store.dispatch('getLidMembers',this.lidId)
      this.candiMembers = this.baseMembers
      this.isStart = true
      this.selectedMembers = []
      if(this.mode=="addLid"||this.mode=="base"){
        this.selectedMembers = this.baseMembers
        this.updatemem()
      }
      if(this.mode=="pj"){
        this.candiMembers = this.lidusers.filter(el => el.isActive === true && el.uid !== undefined)
        this.selectedMembers = this.pjusers.filter(el => el.isActive === true)
        this.updatemem()
        //console.log(this.sanka,this.sanka_copy,this.candiMembers,this.selectedMembers)
      }
      console.log("---------------------------",this.candiMembers,this.onoff,this.sanka);
    },
    methods: {
      updatemem(){
        //全候補メンバー分のonoff/sanka初期化
        for(var i in this.candiMembers) {
          this.onoff[this.candiMembers[i].uid]=false;
          this.sanka[this.candiMembers[i].uid]="不参加";
          this.sanka_copy[this.candiMembers[i].uid]="不参加";
        }
        
        //console.log("this.updatemem",this.candiMembers);
        //参加予定ユーザー全員(selectedMembers)にonoff/sankaの参加タグをつける
        for(let i in this.selectedMembers) {
          //if(this.candiMembers[i].name) 
          this.onoff[this.selectedMembers[i].uid]=true;
          //else this.onoff[this.selectedMembers[i]]=false;
          //if(this.candiMembers[i].name) 
          this.sanka[this.selectedMembers[i].uid]="参加"
          this.sanka_copy[this.selectedMembers[i].uid]="参加"
          //else this.sanka[this.selectedMembers[i]]="不参加";
          //console.log("this.onoff",this.selectedMembers[i],this.onoff[this.selectedMembers[i].uid],this.sanka[this.selectedMembers[i].uid]);
        }
        //console.log("this.onoff",this.namelist,this.onoff,this.sanka,this.candiMembers,this.selectedMembers);
      },
      onChange(id) {
        //on/off(参加/不参加)を切り替える
        //console.log("----旧----",this.onoff[id],this.sanka[id],this.selectedMembers);
        this.onoff[id] = !this.onoff[id];

        //参加状態タグを切り替える
        let newSanka=""
        if (this.sanka[id]=="参加") newSanka="不参加";
        if (this.sanka[id]=="不参加") newSanka="参加";
        this.sanka[id] = newSanka;

        //メンバー(selectedMembers)を全員登録しなおす
        let newMem=[]
        for(let i in this.candiMembers) {
          if(this.onoff[this.candiMembers[i].uid]==true){
            newMem.push(this.candiMembers[i]);
            //console.log(i,newMem,this.onoff[this.candiMembers[i].uid],this.sanka[this.candiMembers[i].uid])
          }
        }
        this.selectedMembers = newMem;

        /* 
        // 新しくなったメンバー(selectedMembers)の状態(onoff,sanka)を登録しなおす
        for(let i in this.selectedMembers) {
          //if(this.candiMembers[i].name) 
          this.onoff[this.selectedMembers[i].uid]=true;
          //else this.onoff[this.selectedMembers[i].uid]=false;
          //if(this.candiMembers[i].name) 
          this.sanka[this.selectedMembers[i].uid]="参加";
          //else this.sanka[this.selectedMembers[i].uid]="不参加";
          //console.log("this.onoff",this.selectedMembers[i],this.onoff[this.selectedMembers[i].uid],this.sanka[this.selectedMembers[i].uid]);
        }
        */
        //console.log("----新----",id,this.namelist[id],this.onoff[id],this.sanka[id],this.selectedMembers);
      },
      ToSanka(k) {
        this.sanka[this.selectedMembers[k].uid]="参加";
      },
      ToHusanka(k) {
        this.sanka[this.selectedMembers[k].uid]="不参加";
      },
      memFilter(k) {
        this.selectedMembers = this.selectedMembers.filter(f=> this.selectedMembers[f].uid !== this.selectedMembers[k].uid);
        //console.log("filter",this.selectedMembers[k].uid,this.selectedMembers)
      },
      count(nn){
        this.usersNum = nn
      },
      submitLidMember(){
        let self = this,i = 0
        // //console.log("管理者登録")
        //console.log("--------",this.candiMembers,this.selectedMembers)
        if(this.selectedMembers.length>0){
          this.candiMembers.forEach((el)=>{
            if(this.sanka[el.uid] == "参加"){ //要検討：二重に登録している
              //console.log("a",el,el.uid,self.namelist[el.uid])
              this.db.collection("0").doc(self.lidId).collection("liduser").doc(el.uid).set({
                uid: el.uid,
                isActive:true
              },{merge:true}).then(function(docRef) {
                // 保存に成功した時
                //console.log(el.uid,"ユーザー登録完了",self.selectedMembers)
                //if(i == self.selectedMembers.length) self.$store.dispatch('getLidMembers',self.lidId)
                self.selectedMembers.forEach((el) => {
                  self.$store.dispatch('setConfigNotify',({title:`${self.$t('Lid')}管理者`,content:`${self.$t('Lid')}:${self.lidTitle}に招待されました。`,address:el.uid,type:5,lidid:self.lidId,tag:"Lid"}))
                })
              }).catch(function(error) {
                // 保存に失敗した時
                console.error("ユーザー登録失敗: ", error)
                alert("Error!:"+error)
              })               
            }
            else if(this.sanka[el.uid] == "不参加"){
              //console.log("--------------------",el.uid)
              //console.log("b",el,el.uid,self.namelist[el.uid])
              this.db.collection("0").doc(self.lidId).collection("liduser").doc(el.uid).set({
                uid: el.uid,
                isActive:false
              },{merge:true}).then(function(docRef) {
                // 保存に成功した時
                //console.log("ユーザー削除完了",self.selectedMembers)
                //if(i == self.selectedMembers.length) self.$store.dispatch('getLidMembers',self.lidId)
              }).catch(function(error) {
                // 保存に失敗した時
                console.error("ユーザー削除失敗: ", error)
                alert("Error!:"+error)
              })  
            }
            i++
          })
          // 削除したメンバーの無効化(isActive=false)
          this.db.collection("0").doc(self.lidId).set({
            updatedAt: firebase.firestore.Timestamp.now(),
            counter:{
              member: self.selectedMembers.length
            }
          },{merge:true}).then(function(docRef) {
            // 保存に成功した時
            //console.log("ユーザー人数更新完了",self.selectedMembers.length)
            self.$store.dispatch('getLidMembers',self.lidId)
          }).catch(function(error) {
            // 保存に失敗した時
            console.error("ユーザー人数更新失敗: ", error)
            alert("Error!:"+error)
          })  
        }
      },
      submitPjMember(){
        let self = this
        this.today()
        //console.log("PJメンバー登録--------",this.sanka,this.sanka_copy,this.candiMembers,this.selectedMembers)
        if(this.selectedMembers.length>0){
          this.candiMembers.forEach((el)=>{
            //console.log(el,el.uid,this.namelist[el.uid],this.sanka[el.uid],this.sanka_copy[el.uid])
            if(this.sanka[el.uid] == "参加"&&this.sanka_copy[el.uid] == "不参加"){ //要検討：二重に登録している
              //console.log("a",el,el.uid,self.namelist[el.uid])
              this.db.collection("0").doc(this.$route.params.id).collection("project").doc(self.pjuid).collection('user').doc(el.uid).set({
                isActive: true,
                uid: this.uid,
                currentName: this.currentName, 
                sort: this.todayy,
                isPermitDele: true,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
              },{merge:true}).then(function(docRef) {
                // 保存に成功した時
                //console.log("ユーザー登録完了",self.namelist[el.uid],el.uid,self.sanka[el.uid])
                self.$store.dispatch('setPjUser',self.selectedMembers)
                self.selectedMembers.forEach((el) => {
                  self.$store.dispatch('setConfigNotify',({title:self.$t('プロジェクト'),content:`${self.$t('プロジェクト')}:${self.aboutpj.title}に招待されました。`,address:el.uid,type:15,lidid:self.lidId,tag:self.$t('プロジェクト')}))
                })
              }).catch(function(error) {
                // 保存に失敗した時
                console.error("ユーザー登録失敗: ", error)
                alert("Error!:"+error)
              })               
            }
            else if(this.sanka[el.uid] == "不参加"&&this.sanka_copy[el.uid] == "参加"){
              //console.log("--------------------",el.uid)
              //console.log("b",el,el.uid,self.namelist[el.uid])
              this.db.collection("0").doc(this.$route.params.id).collection("project").doc(self.pjuid).collection('user').doc(el.uid).set({
                isActive: false,
                uid: this.uid,
                currentName: this.currentName, 
                sort: this.todayy,
                isPermitDele: true,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
              },{merge:true}).then(function(docRef) {
                // 保存に成功した時
                //console.log("ユーザー削除完了",self.namelist[el.uid],el.uid,self.sanka[el.uid])
                self.$store.dispatch('setPjUser',self.selectedMembers)
              }).catch(function(error) {
                // 保存に失敗した時
                console.error("ユーザー登録失敗: ", error)
                alert("Error!:"+error)
              }) 
            }
          })
        }
      },
      toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
        return num; 
      },
      today(){
        // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = this.toDoubleDigits(date.getMonth() + 1)
        let dd = this.toDoubleDigits(date.getDate())
        let hh = this.toDoubleDigits(date.getHours())
        let mi = this.toDoubleDigits(date.getMinutes())
        let se = this.toDoubleDigits(date.getSeconds())
        let ms = this.toDoubleDigits(date.getMilliseconds())
        this.todayy = yyyy + mm + dd + hh + mi + se + ms
      },
    },
    computed: {
      //リスト表示用（検索対応版）
      filteredUsers() {
        // 表示用変数初期化
        var searchedUsers = [];
        //console.log("start",this.candiMembers,this.selectedMembers)
        //参加予定ユーザーを全員検査し、
        for(var k in this.selectedMembers) {
          //console.log("filteruserk",this.onoff[this.selectedMembers[k].uid])
          //onoffがoffになっているユーザーをcandiMembers_copyから排除し、不参加タグを付与する.
          if (this.onoff[this.selectedMembers[k].uid]==false){
            this.memFilter(k)
            this.ToHusanka(k)
            //this.selectedMembers = this.selectedMembers.filter(f=> f !== this.selectedMembers[k]); //computed内では変数を直接変更できないためいったん関数に置き換える
          }
          //onoffがonになっているユーザーには改めて参加状態タグをつける.
          if (this.onoff[this.selectedMembers[k].uid]==true) this.ToSanka(k)
          //console.log(this.selectedMembers[k],this.selectedMembers)
        }
        //console.log(this.selectedMembers);
        //console.log(this.sanka);
        
        // リスト表示用に出力
        if(this.realCondition == "edit"){
          //console.log("edit",this.candiMembers,this.selectedMembers)
          for(var i in this.candiMembers) {
            // //console.log(this.selectedMembers);
            // //console.log(this.candiMembers[i]);
            // //console.log(this.namelist[this.candiMembers[i].uid]);
            // //console.log("--------",this.onoff);

            // 検索用の準備
            let userName = "";
            if (this.namelist[this.candiMembers[i].uid] == null){
              userName = "";
            }else{
              userName = this.namelist[this.candiMembers[i].uid];
            }
            // //console.log(userName);
            //検索キーワードがある場合はそれにそれが含まれているものを抽出、ない場合は全て
            if(userName.indexOf(this.keyword) !== -1) {
              searchedUsers.push(this.candiMembers[i]);
            }
          }          
        }
        else if(this.realCondition == "display"){
          //console.log("display",this.candiMembers,this.selectedMembers)
          var nn = 0
          for(var j in this.selectedMembers) {
            // //console.log(this.candiMembers[j])
            nn++
            // //console.log(this.selectedMembers);
            //console.log("--------",this.onoff);

            // 検索用の準備
            let userName = "";
            if (this.namelist[this.selectedMembers[j].uid] == null){
              userName = "";
            }else{
              userName = this.namelist[this.selectedMembers[j].uid];
            }
            // //console.log(userName);
            if(userName.indexOf(this.keyword) !== -1) {
              searchedUsers.push(this.selectedMembers[j]);
            }
          }
          // 人数出力
          this.count(nn)
        }
        //管理者でmemにないユーザーをmemに代入する （管理者は無条件でmemに入れるため）
        /* 
        for(var j in this.baseMembers) {
          if (this.baseAdmins.gov.includes(this.baseMembers[j].uid)==true && this.selectedMembers.includes(this.baseMembers[j].uid)==false){
            this.selectedMembers.push(this.baseMembers[j].uid);
          }
        }*/
        return searchedUsers;
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      baseAdmins(){
        return this.$store.state.admins
      },
      govstaffs() {
        return this.$store.state.govstaffs;
      },
      baseMembers(){
        return this.$store.state.members
      },
      liqAdmins(){
        return this.$store.state.liqAdmins
      },
      basetitle(){
        return this.$store.state.basetitle
      },
      lidusers(){
        return this.$store.state.lidusers
      },
      namelist(){
        return this.$store.state.namelist
      },
      currentName() {
        return this.$store.state.auth.user.displayName;
      },
      isAdmin(){
        return this.$store.state.isAdmin
      },
      aboutpj(){
        return this.$store.state.aboutpj
      },
      pjusers(){
        return this.$store.state.pjusers
      },
      pjId(){
        return this.$store.state.aboutpj.uid
      }
    },
    watch:{
      lidId:{
        handler: function(v,ov) {
          if(this.mode=="lid"&&(v != ov)&&this.isStart&&v.length>1) {
            this.$store.dispatch('getLidMembers',v)
            console.log("lidid変更検知",ov,v)
          }
        }
      },
      pjId:{
        handler(v){
          //console.log(v)
          if(this.mode=="pj"){
            this.candiMembers = this.lidusers.filter(el => el.isActive === true && el.uid !== undefined)
            this.selectedMembers = this.pjusers.filter(el => el.isActive === true)
            this.updatemem()
            //console.log(this.sanka,this.sanka_copy,this.candiMembers,this.selectedMembers)            
          }
        }
      },
      /* 
      candiMembers:{
        handler: function(v,ov) {
          //console.log("candiMembers変更検知",ov,v)
          //if(v.length>0&&ov!==v&&this.mode!=="addLid") this.updatemem()
        }
      },
      */
      lidusers:{
        handler: function(v,ov) {
          console.log("lidusers変更",ov,v)
          if(v.length>0&&ov!==v&&this.mode!=="addLid") {
            this.selectedMembers = this.lidusers.filter(el => el.isActive === true && el.uid !== undefined)
            this.updatemem()
          }
        }
      }
      
    }, 
}
</script>
<style scoped>
.close{
  position: fixed;
  right: 1%;
  top: 1%;
  width: 4%;
}
.v-checkbox:active {
    background-color: red !important;
}
.abyssFont{
  color: #294A66;
}
.deepAlgae{
  color: #399942;
}
</style>
